<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xB2bu1/tc-custom/9781473816916.jpg?1729082793547" alt="This image is the cover for the book One More River To Cross"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One More River To Cross
      </h1>
      <p class="bookDescription body article font2">
        <p>Military bridging, often impeded by mines and hostile enemy fire, is a vital part of the advance of any modern army. Britain's Royal Engineers have played a leading role in this crucial military operation, from the ravines behind the D-Day beaches to recent operations in Bosnia and Kosovo. The Royal Engineers have displayed incredible ingenuity in developing responses to the increasing amounts of firepower directed at bridging troops. This definitive study has been prepared with the assistance of the Royal Engineers and contains details on 170 pieces of bridging equipment, the history of all Royal Engineer assault squadrons, and accounts of all Victoria Crosses won during bridging actions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. H. Joiner
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Leo Cooper
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19d21528